module.exports = __webpack_public_path__ + "30932d3877b0b61299e9b543873b21ea.jpg";